import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

type EventStatus = '진행중' | '예정' | '종료';

interface Event {
  id: number;
  status: EventStatus;
  title: string;
  subtitle: string;
  period: string;
  location: string;
  desc: string;
  tag: string;
  image: string;
}

const events: Event[] = [
  {
    id: 1,
    status: '진행중',
    title: '봄 라인워크 특가 이벤트',
    subtitle: 'Spring Line Art Special',
    period: '2026.04.01 — 2026.04.30',
    location: '전국 가맹점',
    desc: '봄 시즌을 맞아 소형 라인워크 작품 20% 할인 혜택을 제공합니다. 각 가맹점별 선착순 10명 한정으로 진행되며, 예약 시 이벤트 코드 SPRING26을 입력해 주세요.',
    tag: '할인',
    image: 'https://public.readdy.ai/ai/img_res/74b66c9969aa84fa7dc642e6a601abb3.jpg',
  },
  {
    id: 2,
    status: '진행중',
    title: '선율 아카데미 2기 모집',
    subtitle: 'Academy 2nd Cohort',
    period: '2026.03.20 — 2026.05.15',
    location: '서울 청담 플래그십',
    desc: '6개월 집중 과정으로 라인워크 전문 아티스트를 양성합니다. 포트폴리오 심사 후 최종 8명을 선발하며, 수료 후 가맹점 취업 연계 프로그램이 제공됩니다.',
    tag: '모집',
    image: 'https://readdy.ai/api/search-image?query=tattoo%20artist%20academy%20education%20professional%20training%20studio%20Korea%20elegant%20minimalist%20interior%20students%20learning%20fine%20line%20art%20premium%20atmosphere&width=700&height=480&seq=event_academy1&orientation=landscape',
  },
  {
    id: 3,
    status: '예정',
    title: '2026 상반기 가맹 설명회',
    subtitle: 'Franchise Seminar',
    period: '2026.05.03 — 2026.06.07',
    location: '서울 청담 플래그십',
    desc: '매월 첫째 주 토요일 오후 2시, 선율 청담 플래그십 스토어에서 가맹 설명회가 진행됩니다. 창업 비용, 수익 구조, 본사 지원 시스템 전반에 대한 상세 안내가 제공됩니다.',
    tag: '설명회',
    image: 'https://readdy.ai/api/search-image?query=elegant%20business%20seminar%20presentation%20luxury%20studio%20interior%20Korea%20professional%20franchise%20meeting%20minimalist%20white%20space%20warm%20lighting%20editorial%20photography&width=700&height=480&seq=event_seminar1&orientation=landscape',
  },
  {
    id: 4,
    status: '예정',
    title: '여름 미니멀 타투 캠페인',
    subtitle: 'Summer Minimal Campaign',
    period: '2026.06.01 — 2026.08.31',
    location: '전국 가맹점',
    desc: '여름 시즌 노출 부위에 어울리는 미니멀 타투 캠페인입니다. 손목, 발목, 쇄골 등 소형 작품 전문 패키지를 특별 가격으로 제공합니다.',
    tag: '캠페인',
    image: 'https://readdy.ai/api/search-image?query=minimal%20small%20tattoo%20design%20summer%20wrist%20ankle%20collarbone%20fine%20line%20art%20elegant%20white%20background%20clean%20studio%20photography%20premium%20aesthetic%20Korea&width=700&height=480&seq=event_summer1&orientation=landscape',
  },
  {
    id: 5,
    status: '종료',
    title: '창립 8주년 고객 감사 이벤트',
    subtitle: '8th Anniversary',
    period: '2026.02.01 — 2026.02.28',
    location: '전국 가맹점',
    desc: '선율 창립 8주년을 기념하여 전국 가맹점에서 시술 고객 대상 기념 굿즈 증정 및 추첨을 통한 무료 시술권 제공 이벤트를 진행하였습니다.',
    tag: '기념',
    image: 'https://readdy.ai/api/search-image?query=anniversary%20celebration%20elegant%20luxury%20tattoo%20studio%20Korea%208%20years%20premium%20brand%20event%20minimalist%20dark%20background%20gold%20accent%20editorial%20photography&width=700&height=480&seq=event_anniv1&orientation=landscape',
  },
  {
    id: 6,
    status: '종료',
    title: '겨울 커플 타투 패키지',
    subtitle: 'Winter Couple Package',
    period: '2025.12.01 — 2026.01.31',
    location: '전국 가맹점',
    desc: '커플 동반 시술 시 2인 합산 15% 할인 혜택을 제공하는 겨울 시즌 이벤트입니다. 매칭 라인워크 디자인 무료 상담 서비스도 함께 제공되었습니다.',
    tag: '패키지',
    image: 'https://readdy.ai/api/search-image?query=couple%20matching%20tattoo%20design%20fine%20line%20art%20winter%20minimal%20elegant%20white%20background%20premium%20studio%20photography%20Korea%20clean%20aesthetic%20romantic&width=700&height=480&seq=event_couple1&orientation=landscape',
  },
];

const statusFilters: EventStatus[] = ['진행중', '예정', '종료'];
const allFilters = ['전체', ...statusFilters];

const statusStyles: Record<EventStatus, { bg: string; color: string; border: string }> = {
  '진행중': { bg: '#C9A96E15', color: '#C9A96E', border: '#C9A96E40' },
  '예정': { bg: '#1A1A1A10', color: '#1A1A1A', border: '#1A1A1A30' },
  '종료': { bg: '#88888815', color: '#888888', border: '#88888830' },
};

function EventsHero() {
  return (
    <section className="relative pt-40 pb-24 bg-[#1A1A1A] overflow-hidden">
      <div className="absolute inset-0 opacity-50">
        <img
          src="https://readdy.ai/api/search-image?query=exclusive%20luxury%20brand%20event%20exhibition%20space%20Seoul%20Korea%20dark%20moody%20atmosphere%20gold%20accent%20lighting%20minimal%20black%20interior%20elegant%20guests%20silhouettes%20art%20gallery%20opening%20night%20cinematic%20wide%20angle%20photography%20premium%20atmosphere&width=1440&height=500&seq=events_hero_v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#1A1A1A]/30 via-transparent to-[#1A1A1A]/60" />
      <div className="relative z-10 max-w-[1440px] mx-auto px-8 md:px-16 text-center">
        <div className="flex items-center justify-center gap-2 mb-10">
          <Link
            to="/community"
            className="text-[10px] tracking-[0.3em] uppercase text-white/30 hover:text-white/60 transition-colors cursor-pointer"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Community
          </Link>
          <span className="text-white/20 text-xs">/</span>
          <span
            className="text-[10px] tracking-[0.3em] uppercase text-[#C9A96E]"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            이벤트
          </span>
        </div>
        <h1
          className="text-4xl md:text-6xl text-white mb-6 leading-tight"
          style={{ fontFamily: "'Cinzel', serif", fontWeight: 300, letterSpacing: '0.1em' }}
        >
          Events
        </h1>
        <p
          className="text-sm text-white/50 leading-relaxed max-w-lg mx-auto"
          style={{ fontFamily: "'Noto Sans KR', sans-serif", lineHeight: '1.8' }}
        >
          선율의 특별한 이벤트와 캠페인 소식을 만나보세요.
        </p>
        <div className="mx-auto mt-12 h-px bg-white/15" style={{ width: '80px' }} />
      </div>
    </section>
  );
}

function EventsGrid() {
  const [activeFilter, setActiveFilter] = useState('전체');

  const filtered = activeFilter === '전체'
    ? events
    : events.filter((e) => e.status === activeFilter);

  return (
    <section className="py-20 md:py-28 bg-[#FAFAFA]">
      <div className="max-w-[1440px] mx-auto px-8 md:px-16">

        {/* Filter tabs */}
        <div className="flex items-center gap-2 mb-14 flex-wrap">
          {allFilters.map((f) => (
            <button
              key={f}
              onClick={() => setActiveFilter(f)}
              className="px-5 py-2 text-xs tracking-[0.15em] uppercase transition-all duration-200 cursor-pointer whitespace-nowrap rounded-full"
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                background: activeFilter === f ? '#1A1A1A' : 'transparent',
                color: activeFilter === f ? '#FFFFFF' : '#888888',
                border: activeFilter === f ? '1px solid #1A1A1A' : '1px solid #E5E5E5',
              }}
            >
              {f}
            </button>
          ))}
          <span
            className="ml-auto text-xs text-[#AAAAAA]"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            {filtered.length}개 이벤트
          </span>
        </div>

        {/* Event Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((event) => {
            const style = statusStyles[event.status];
            const isEnded = event.status === '종료';
            return (
              <div
                key={event.id}
                className="bg-white border border-[#EBEBEB] overflow-hidden group cursor-default"
                style={{ opacity: isEnded ? 0.7 : 1 }}
              >
                {/* Image */}
                <div className="relative w-full h-52 overflow-hidden">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    style={{ filter: isEnded ? 'grayscale(60%)' : 'none' }}
                  />
                  {/* Status badge */}
                  <div className="absolute top-4 left-4">
                    <span
                      className="px-3 py-1 text-[10px] tracking-[0.12em] uppercase font-semibold rounded-full"
                      style={{
                        fontFamily: "'Montserrat', sans-serif",
                        background: style.bg,
                        color: style.color,
                        border: `1px solid ${style.border}`,
                        backdropFilter: 'blur(8px)',
                        backgroundColor: isEnded ? 'rgba(255,255,255,0.85)' : 'rgba(255,255,255,0.9)',
                      }}
                    >
                      {event.status}
                    </span>
                  </div>
                  {/* Tag */}
                  <div className="absolute top-4 right-4">
                    <span
                      className="px-2.5 py-1 text-[10px] tracking-[0.1em] font-medium rounded-full"
                      style={{
                        fontFamily: "'Montserrat', sans-serif",
                        background: 'rgba(26,26,26,0.75)',
                        color: '#FFFFFF',
                        backdropFilter: 'blur(8px)',
                      }}
                    >
                      {event.tag}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <p
                    className="text-[10px] tracking-[0.2em] uppercase text-[#C9A96E] mb-2"
                    style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 500 }}
                  >
                    {event.subtitle}
                  </p>
                  <h3
                    className="text-base font-semibold text-[#1A1A1A] mb-3 leading-snug"
                    style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                  >
                    {event.title}
                  </h3>
                  <p
                    className="text-xs text-[#888] leading-relaxed mb-5 line-clamp-2"
                    style={{ fontFamily: "'Noto Sans KR', sans-serif", lineHeight: '1.75' }}
                  >
                    {event.desc}
                  </p>

                  {/* Meta */}
                  <div className="flex flex-col gap-2 pt-4 border-t border-[#F5F5F5]">
                    <div className="flex items-center gap-2">
                      <i className="ri-calendar-line text-[#CCCCCC] text-xs" />
                      <span
                        className="text-xs text-[#AAAAAA]"
                        style={{ fontFamily: "'Montserrat', sans-serif" }}
                      >
                        {event.period}
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-map-pin-line text-[#CCCCCC] text-xs" />
                      <span
                        className="text-xs text-[#AAAAAA]"
                        style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                      >
                        {event.location}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-16 pt-12 border-t border-[#E5E5E5] text-center">
          <p
            className="text-sm text-[#888] mb-6"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            이벤트 관련 문의 또는 가맹 창업에 관심이 있으신가요?
          </p>
          <Link
            to="/community/inquiry"
            className="inline-flex items-center gap-2 px-10 py-4 bg-[#1A1A1A] text-white text-xs tracking-[0.18em] uppercase font-medium hover:bg-[#333] transition-colors duration-300 cursor-pointer whitespace-nowrap rounded-full"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            가맹 문의하기
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default function EventsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <EventsHero />
        <EventsGrid />
      </main>
      <Footer />
    </div>
  );
}
